import { UNDEFINED_TAG, UNTAGGED_TAG, } from "../../../dsp/signal/helpers/to-path.js";
export const mapToHistogramData = (projectionMap, projectionData) => {
    let histogramDataDistribution = Object.values(projectionMap).reduce((distribution, projectionDef) => {
        distribution[projectionDef.tag] = {
            key: projectionDef.tag,
            label: projectionDef.label,
            index: projectionDef.index,
            color: projectionDef.stroke[0].color,
            value: 0,
            count: 0,
        };
        return distribution;
    }, {});
    let histogramData = projectionData.reduce((pcd, tagProjection) => {
        if (tagProjection.tag !== "_undefined" && projectionMap[tagProjection.tag] != undefined) {
            if (!pcd.distribution[tagProjection.tag]) {
                pcd.distribution[tagProjection.tag] = {
                    key: tagProjection.tag,
                    label: projectionMap[tagProjection.tag].label,
                    color: projectionMap[tagProjection.tag].stroke[0].color,
                    index: projectionMap[tagProjection.tag].index,
                    value: tagProjection.end - tagProjection.start,
                    count: 1,
                };
            }
            else {
                pcd.distribution[tagProjection.tag].value +=
                    tagProjection.end - tagProjection.start;
                pcd.distribution[tagProjection.tag].count++;
            }
            pcd.max =
                pcd.max === undefined
                    ? tagProjection.tag
                    : pcd.distribution[tagProjection.tag].value >
                        pcd.distribution[pcd.max].value
                        ? tagProjection.tag
                        : pcd.max;
            pcd.min =
                pcd.min === undefined
                    ? tagProjection.tag
                    : pcd.distribution[tagProjection.tag].value <
                        pcd.distribution[pcd.min].value
                        ? tagProjection.tag
                        : pcd.min;
            pcd.count++;
        }
        return pcd;
    }, {
        title: "",
        distribution: histogramDataDistribution,
        count: 0,
        max: undefined,
        min: undefined,
    });
    histogramData.distribution = Object.values(histogramData.distribution)
        .sort((d0, d1) => d0.index - d1.index)
        .reduce((distribution, entry) => {
        distribution[entry.key] = entry;
        return distribution;
    }, {});
    return histogramData;
};
export const mapToTagDefinitions = (tagParameters, locale) => {
    return tagParameters
        ? tagParameters
            //define a tag when not done already
            .map((tagParameter, i) => 
        //define a tag when not defined
        //define a label when not defined
        //copy the stroke definitions
        Object.assign({
            tag: "_" + tagParameter.value,
            label: `>= ${tagParameter.value.toLocaleString(locale)}`,
        }, tagParameter, {
            stroke: tagParameter.stroke.map((stroke) => Object.assign({}, stroke)),
        }))
            .sort((t0, t1) => t0.value - t1.value)
            .reverse()
            .map((tagParameter, i) => 
        //add an index property
        Object.assign(tagParameter, {
            index: i,
        }))
        : [];
};
export const mapToTagMap = (tagDefinitions, untaggedColors, undefinedColors, locale) => {
    const thresholdMap = tagDefinitions.reduce((sm, threshold) => {
        sm[threshold.tag] = threshold;
        return sm;
    }, {});
    thresholdMap[UNTAGGED_TAG] = {
        value: 0,
        tag: UNTAGGED_TAG,
        label: tagDefinitions && tagDefinitions.length > 0
            ? `< ${tagDefinitions[tagDefinitions.length - 1].value.toLocaleString(locale)}`
            : "",
        index: tagDefinitions && tagDefinitions.length > 0
            ? tagDefinitions[tagDefinitions.length - 1].index + 1
            : 0,
        stroke: untaggedColors.map((color) => {
            return { color };
        }),
    };
    thresholdMap[UNDEFINED_TAG] = {
        value: 0,
        tag: UNDEFINED_TAG,
        label: "?",
        index: thresholdMap[UNTAGGED_TAG].index + 1,
        stroke: undefinedColors.map((color) => {
            return { color };
        }),
    };
    return thresholdMap;
};
